import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Resources.css";
import "./HomePage.css";
import PageHeader from "./components/PageHeader.js";

export default function Moderation() {
  const apiUrl = process.env.REACT_APP_API_URL || "";
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [flagged, setFlagged] = useState([]);
  const [adminKey, setAdminKey] = useState(() => {
    try { return localStorage.getItem("zolaid_market_admin_key") || ""; } catch (_) { return ""; }
  });

  const refresh = async () => {
    try {
      setError("");
      setLoading(true);
      const endpoint = apiUrl ? `${apiUrl}/market/templates/flagged` : "/market/templates/flagged";
      const resp = await axios.get(endpoint, { headers: adminKey ? { "x-admin-key": adminKey } : {} });
      setFlagged(Array.isArray(resp.data?.templates) ? resp.data.templates : []);
    } catch (e) {
      console.error("moderation load failed", e);
      setError(e?.response?.data?.error || "Failed to load flagged templates.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unflag = async (id) => {
    try {
      setError("");
      const endpoint = apiUrl ? `${apiUrl}/market/templates/unflag` : "/market/templates/unflag";
      await axios.post(endpoint, { id }, { headers: adminKey ? { "x-admin-key": adminKey } : {} });
      await refresh();
    } catch (e) {
      console.error("unflag failed", e);
      setError(e?.response?.data?.error || "Failed to unflag.");
    }
  };

  const del = async (id) => {
    try {
      setError("");
      const ok = window.confirm("Delete this template from the marketplace? (prototype)");
      if (!ok) return;
      const endpoint = apiUrl ? `${apiUrl}/market/templates/delete` : "/market/templates/delete";
      await axios.post(endpoint, { id }, { headers: adminKey ? { "x-admin-key": adminKey } : {} });
      await refresh();
    } catch (e) {
      console.error("delete failed", e);
      setError(e?.response?.data?.error || "Failed to delete.");
    }
  };

  return (
    <div className="resources-page">
      <PageHeader
        customNav={[
          { label: "Resources", to: "/Resources" },
          { label: "Templates", to: "/Templates" },
          { label: "Moderation", to: "/Moderation" },
        ]}
      />

      <div className="resources-content">
        <h1>Marketplace Moderation (Prototype)</h1>
        <p className="resources-subtitle">
          Review flagged community templates. (No auth yet; do not expose publicly.)
        </p>

        <section style={sectionStyle}>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 10 }}>
            <input
              value={adminKey}
              onChange={(e) => {
                const v = e.target.value;
                setAdminKey(v);
                try { localStorage.setItem("zolaid_market_admin_key", v); } catch (_) {}
              }}
              placeholder="Admin key (MARKET_ADMIN_KEY)"
              style={{
                flex: "1 1 260px",
                padding: "10px 12px",
                borderRadius: 12,
                border: "1px solid rgba(255,255,255,0.12)",
                background: "rgba(0,0,0,0.18)",
                color: "#ffffff",
                outline: "none",
              }}
            />
            <button className="generate-btn" type="button" onClick={refresh} disabled={loading}>
              {loading ? "Loading..." : "Load"}
            </button>
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "space-between", alignItems: "center" }}>
            <h2 style={{ margin: 0 }}>Flagged templates</h2>
            <button className="generate-btn" type="button" onClick={refresh} disabled={loading}>
              {loading ? "Loading..." : "Refresh"}
            </button>
          </div>
          {error && <div style={{ marginTop: 8, color: "#ffb4b4", fontSize: 12 }}>{error}</div>}

          {flagged.length === 0 ? (
            <div style={{ marginTop: 10, color: "rgba(255,255,255,0.75)" }}>No flagged templates.</div>
          ) : (
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
              {flagged.slice(0, 50).map((t) => (
                <div key={t.id} style={cardStyle}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 900 }}>{t.name || "Template"}</div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.72)" }}>
                      {t.id} â€¢ reports {Number(t.reports || 0)} â€¢ last {t.lastReportAt ? new Date(t.lastReportAt).toLocaleString() : ""}
                    </div>
                    {t.description ? (
                      <div style={{ marginTop: 6, fontSize: 12, color: "rgba(255,255,255,0.78)" }}>{String(t.description)}</div>
                    ) : null}
                  </div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
                    <button className="generate-btn" type="button" onClick={() => unflag(t.id)}>
                      Unflag
                    </button>
                    <button className="cancel-btn" type="button" onClick={() => del(t.id)}>
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>

      <footer className="resources-footer">
        <p>Â© 2025 ZOLAID. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/PrivacyPolicy">Privacy Policy</Link>
          <span>|</span>
          <Link to="/TermsOfService">Terms of Service</Link>
          <span>|</span>
          <Link to="/Contact">Contact</Link>
        </div>
      </footer>
    </div>
  );
}

const sectionStyle = {
  padding: "14px 16px",
  borderRadius: 14,
  border: "1px solid rgba(255,255,255,0.10)",
  background: "rgba(255,255,255,0.04)",
  marginBottom: 12,
};

const cardStyle = {
  display: "flex",
  gap: 10,
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px 12px",
  borderRadius: 14,
  border: "1px solid rgba(255,255,255,0.10)",
  background: "rgba(255,255,255,0.03)",
};

